(function ($, Drupal, drupalSettings) {
  Drupal.behaviors.galerie = {
    attach: function (context, settings) {
      $('.paragraph--galerie', context).once('galerie').each(function () {
        var that = $(this);
        var carousel = that.find(".swiper-container");

        new Swiper(carousel[0], {
          watchOverflow: true,
          spaceBetween: 2,
          slidesPerView: "auto",
          navigation: {
            nextEl: that.find('.custom-button-next')[0],
            prevEl: that.find('.custom-button-prev')[0],
          },
          autoplay: {
            delay: 5000,
            disableOnInteraction: false,
          },
        });
      });
    }
  }
})(jQuery, Drupal, drupalSettings);
